import { Pipe, PipeTransform } from '@angular/core';

/**
	* @ngdoc filter
	* @description
	* Angular filter for capping a displayed count, appending a '+' when the value exceeds the max
	*
	* @param count - the number to display
	* @param max - the highest count to display before truncating, defaults to 99
	* @usage
	* {{ pendingPaymentCount | async | maxCount }}
	* {{ someCount | maxCount:999 }}
	*/

@Pipe({
	name: 'maxCount',
})
export class MaxCountPipe implements PipeTransform {

	transform(count: number, max: number = 99): string {
		if (count == null) {
			return '';
		}

		return count > max ? `${max}+` : String(count);
	}

}
